import { ValuableModel } from '../../models/ValuableModel'

export class SchemaNullModel extends ValuableModel {}

declare global {
  export interface RehajeViewModels {
    'Schema.Null': SchemaNullModel
  }
}
